import { normalizeSpecialsDisplayName } from '@iheartjane/menu';
import find from 'lodash-es/find';
import get from 'lodash-es/get';
import upperFirst from 'lodash-es/upperFirst';

import type { CustomLabel, MenuRow, MenuTab } from '@jane/business-admin/types';

export const CARD_WIDTH = 253;
export const CARD_HEIGHT = 352;

export const getRowLabel = (
  row: MenuRow,
  customProductTypeLabels?: CustomLabel[],
  useMenuRowType?: boolean,
  thematicRows: boolean = false
) => {
  const rowTypeValue = useMenuRowType ? row.menu_row_type : row.row_type;

  if (row.is_category) {
    return get(
      find(customProductTypeLabels, {
        product_subtype: null,
        product_type: rowTypeValue,
      }),
      'custom_label',
      upperFirst(rowTypeValue ?? undefined)
    );
  } else {
    if (rowTypeValue === 'magic_row') {
      return `Recommended${thematicRows ? ' row' : ''}`;
    }
    if (rowTypeValue === 'specials') {
      return normalizeSpecialsDisplayName(row.custom_display_name);
    }
    return row.custom_display_name || rowTypeValue;
  }
};

export const getTabLabel = (
  tab: MenuTab,
  customProductTypeLabels?: CustomLabel[]
) => {
  const customLabel = get(
    find(customProductTypeLabels, {
      product_subtype: null,
      product_type: tab.tab_name,
    }),
    'custom_label'
  );

  if (customLabel) {
    return customLabel;
  }

  if (tab.tab_name === 'all-products') {
    return 'All products';
  }
  if (tab.tab_name === 'brand_specials') {
    return 'Jane Gold';
  }
  if (tab.tab_name === 'specials') {
    return 'Deals';
  }
  return upperFirst(tab.tab_name);
};
